/* custom-header-scroll.js — hides the fixed header bar when scrolling
   down, reveals it when scrolling up. The bar is position:fixed (see
   custom-header.liquid for why), so this also:
   1. reserves its height on the outer <header> so page content doesn't
      jump up underneath it, and
   2. listens for scroll on Horizon's actual scrolling element
      (.page-wrapper, not window — Horizon scrolls that flex container
      internally rather than the document). */
(function () {
  var bar = document.querySelector('[data-header-bar]');
  var header = bar ? bar.closest('.custom-header') : null;
  var scroller = document.querySelector('.page-wrapper') || window;
  if (!(bar instanceof HTMLElement) || !(header instanceof HTMLElement)) return;

  function scrollY() {
    return scroller === window ? window.scrollY : /** @type {HTMLElement} */ (scroller).scrollTop;
  }

  function syncHeight() {
    header.style.minHeight = bar.offsetHeight + 'px';
  }

  syncHeight();
  window.addEventListener('resize', syncHeight);
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(syncHeight).observe(bar);
  }

  var lastY = scrollY();
  var ticking = false;
  var threshold = 8;

  function onScroll() {
    var currentY = scrollY();
    var delta = currentY - lastY;

    if (currentY <= bar.offsetHeight) {
      bar.classList.remove('is-hidden');
    } else if (delta > threshold) {
      bar.classList.add('is-hidden');
      lastY = currentY;
    } else if (delta < -threshold) {
      bar.classList.remove('is-hidden');
      lastY = currentY;
    }

    ticking = false;
  }

  scroller.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();


/* Accessibility (18 Oct 2026): a third-party app script (Textify's textbox.js)
   injects <meta name="viewport" ... maximum-scale=1.0, user-scalable=no>,
   which blocks pinch-zoom on phones (WCAG 1.4.4). Remove any viewport tag that
   disables zoom, whenever it is added. The theme's own viewport tag
   (width=device-width,initial-scale=1) is left alone. */
(function () {
  function fix() {
    document.querySelectorAll('meta[name="viewport"]').forEach(function (m) {
      var c = (m.getAttribute('content') || '').toLowerCase().replace(/\s+/g, '');
      if (/user-scalable=(no|0)/.test(c) || /maximum-scale=1(\.0+)?(,|$)/.test(c)) m.remove();
    });
  }
  fix();
  if (window.MutationObserver) {
    new MutationObserver(fix).observe(document.head || document.documentElement, { childList: true, subtree: true });
  }
})();
